<div class="snack-bar-content">
  <div [innerHTML]="data.message"></div>
  <button mat-button (click)="closeSnackBar()">
    {{ data.closeButtonText }}
  </button>
</div>
